export class EndpointsConfig {
  static login = '/auth/login/email';
  static logout = '/auth/logout';
  static socialLogin = '/auth/login/social';
  static refresh = '/auth/refresh';
  static me = '/users/me';
  static usersFilters = '/users/filters';
  static partnersFilters = '/partners/filters';
  static partnersFirstLetters = '/partners/first-letter';
  static partnersBulkEdit = '/partners/bulk-update';
  static partnersExport = '/partners/export';
  static partnersExportEmail = '/partners/export/email';
  static partnersTotalCount = '/partners/count';
  static users = '/users';
  static usersListByRole = '/users/list-by-roles';
  static usersCheckEmail = '/users/check';
  static usersCheckPhone = '/users/check/phone';
  static countries = '/countries';
  static offices = '/offices';
  static partners = '/partners';
  static candidates = '/candidates';
  static candidatesFirstLetters = '/candidates/first-letter';
  static candidatesFilters = '/candidates/filters';
  static candidatesBulkEdit = '/candidates/bulk-update';
  static candidatesExport = '/candidates/export';
  static candidatesExportEmail = '/candidates/export/email';
  static candidatesTotalCount = '/candidates/count';
  static phoneContactsList = '/phone-contacts/list';
  static phoneContacts = '/phone-contacts';
  static phoneContactsExport = '/phone-contacts/list/export';
  static phoneContactsExportEmail = '/phone-contacts/list/export/email';
  static phoneContactsFirstLetters = '/phone-contacts/first-letter';
  static phoneContactsFiltersDropdown = '/phone-contacts/filters/dropdown';
  static phoneContactsFilters = '/phone-contacts/filters';
  static phoneContactsTotalCount = '/phone-contacts/list/count';
  static positionApplications = '/position-applications/list';
  static positionApplicationsFilter = '/position-applications/filters';
  static positionApplicationsFirstLetters = '/position-applications/first-letter';
  static positionApplicationsFilterDropdown = '/position-applications/filters/dropdown';
  static positionApplicationTotalCount = '/position-applications/list/count';
  static positionApplicationsExport = '/position-applications/list/export';
  static positionApplicationsExportEmail = '/position-applications/list/export/email';
  static sources = '/sources';
  static jobTypes = '/job-types';
  static specializations = '/specializations';
  static languages = '/languages';
  static languageLevels = '/languages/levels';
  static documentTypes = '/candidates/document-types';
  static userAvatar = '/users/avatar';
  static employmentTypes = '/employment-types';
  static partnersDropdown = '/partners/dropdown';
  static positions = '/positions';
  static positionTypes = '/positions/types';
  static positionsFirstLetters = '/positions/first-letter';
  static positionsFilters = '/positions/filters';
  static positionsBulkEdit = '/positions/bulk-update';
  static positionsExport = '/positions/export';
  static positionsExportEmail = '/positions/export/email';
  static positionsTotalCount = '/positions/count';
  static candidateCustomFields = '/custom-field-types';
  static educationTypes = '/education-types';
  static workExperiences = '/work-experiences';
  static boardColumns = '/positions/statuses';
  static boardTableFilterDropdown = '/positions/candidates/table/list/filters/dropdown';
  static boardTableFilters = '/positions/candidates/table/list/filters';
  static boardTableFirstLetters = (positionId: number) =>
    `/positions/${positionId}/candidates/table/list/first-letter`;
  static tags = '/tags';
  static providerTypes = '/provider-types';
  static providerTypesManual = 'provider-types/manual';
  static projectManagers = 'users/dropdown?role=project-manager';
  static projectSpecializations = '/project-specializations';
  static tableViews = `/table-views`;
  static backendConfig = `/configs`;
  static boardColumnsByPositionId = (positionId: number) => `/positions/${positionId}/statuses`;
  static positionsDropdown = (projectId: number) => `/projects/${projectId}/positions/dropdown`;
  static notifications = (userId: number) => `users/${userId}/notifications`;
  static notificationsMarkAsRead = (userId: number) =>
    `/users/${userId}/notifications/mark-as-read`;
  static reSendNotification = (userId: number) => `/users/${userId}/notifications/re-send`;
  static checkRoleChange = (userId: number) => `/users/${userId}/check-role-change`;
  static checkHasRelations = (userId: number) => `/users/${userId}/check-has-relation`;
  static userById = (userId: number) => `/users/${userId}`;
  static boardCandidates = (positionId: number) => `/positions/${positionId}/candidates`;
  static boardCandidatesForTable = (positionId: number) =>
    `/positions/${positionId}/candidates/table/list`;
  static boardCandidate = (positionId: number, userId: number) =>
    `/positions/${positionId}/candidates/${userId}`;
  static exportBoardCandidateById = (positionId: number) =>
    `/positions/${positionId}/candidates/table/list/export`;
  static exportEmailBoardCandidateById = (positionId: number) =>
    `/positions/${positionId}/candidates/table/list/export/email`;
  static searchBoardCandidate = (positionId: number) =>
    `/positions/${positionId}/candidates/search`;
  static moveOrAddBoardCandidate = (positionId: number, candidateId: number) =>
    `/positions/${positionId}/candidates/${candidateId}`;
  static moveOrAddBoardPhoneContact = (positionId: number, candidateId: number) =>
    `/positions/${positionId}/candidates/${candidateId}/phone-contacts`;
  static providers = (advertisementId: number) => `/vacancies/${advertisementId}/providers`;
  static providerById = (advertisementId: number, providerId: number) =>
    `/vacancies/${advertisementId}/providers/${providerId}`;
  static positionStatus = (positionId: number) => `/positions/${positionId}/status`;
  static providerStatus = (advertisementId: number, providerId: number) =>
    `/vacancies/${advertisementId}/providers/${providerId}/status`;
  static advertisement = (positionId: number) => `/positions/${positionId}/vacancies`;
  static advertisementById = (positionId: number, advertisementId: number) =>
    `/positions/${positionId}/vacancies/${advertisementId}`;
  static advertisementImage = (advertisementId: number) =>
    `/vacancies/${advertisementId}/documents`;
  static advertisementImageById = (advertisementId: number, imageId: number) =>
    `/vacancies/${advertisementId}/documents/${imageId}`;
  static positionById = (positionId: number) => `/positions/${positionId}`;
  static positionHistory = (positionId: number) => `/positions/${positionId}/history`;
  static positionHistoryWithId = (positionId: number, historyId: number) =>
    `/positions/${positionId}/history/${historyId}`;
  static downloadCandidateDocuments = (candidateId: number, documentId: number) =>
    `/candidates/${candidateId}/document/${documentId}`;
  static candidateSetProfileReadStatus = (candidateId: number) => `candidates/${candidateId}/read`;
  static candidatePosition = (candidateId: number) => `/candidates/${candidateId}/positions`;
  static candidateAllPositions = (candidateId: number) =>
    `/candidates/${candidateId}/positions/dropdown`;
  static candidateHistory = (candidateId: number) => `/candidates/${candidateId}/history`;
  static candidateHistoryWithId = (candidateId: number, historyId: number) =>
    `/candidates/${candidateId}/history/${historyId}`;
  static candidateDocuments = (candidateId: number) => `/candidates/${candidateId}/document`;
  static candidatesById = (candidateId: number) => `/candidates/${candidateId}`;
  static addSystemTag = (candidateId: number) => `/system-tags/candidate/${candidateId}`;
  static candidatePositionAttach = (candidateId: number) =>
    `/candidates/${candidateId}/positions/attach`;
  static candidatePositionDetach = (candidateId: number, positionId: number) =>
    `/candidates/${candidateId}/positions/${positionId}`;
  static citySearch = (countryId: number) => `/countries/${countryId}/cities/search`;
  static cities = (countryShortName: string) => `/countries/${countryShortName}/cities`;
  static partnerById = (partnerId: number) => `/partners/${partnerId}`;
  static partnerHistory = (partnerId: number) => `/partners/${partnerId}/history`;
  static projects = (partnerId: number) => `/partners/${partnerId}/projects`;
  static projectById = (partnerId: number, projectId: number) =>
    `/partners/${partnerId}/projects/${projectId}`;
  static projectHistory = (projectId: number) => `/projects/${projectId}/history`;
  static projectPositions = (projectId: number) => `/projects/${projectId}/positions`;
  static partnerHistoryById = (partnerId: number, historyId: number) =>
    `/partners/${partnerId}/history/${historyId}`;
  static projectHistoryById = (projectId: number, historyId: number) =>
    `/projects/${projectId}/history/${historyId}`;
  static projectStatus = (partnerId: number, projectId: number) =>
    `/partners/${partnerId}/projects/${projectId}/status`;
  static sourceDeleteById = (sourceId: number) => `/sources/${sourceId}/delete`;
  static sourceUpdateById = (sourceId: number) => `/sources/${sourceId}`;
  static sourceArchiveById = (sourceId: number) => `/sources/${sourceId}/archive`;
  static sourceActivateById = (sourceId: number) => `/sources/${sourceId}/activate`;
  static sourceCheckUsageById = (sourceId: number) => `/sources/${sourceId}/check-usage`;
  static customFieldDeleteById = (customFieldId: number) => `/custom-field-types/${customFieldId}`;
  static customFieldTypeEditById = (customFieldId: number) =>
    `/custom-field-types/${customFieldId}`;
  static tableViewDeleteById = (viewId: number) => `/table-views/${viewId}`;
  static tableViewEditById = (viewId: number) => `/table-views/${viewId}`;
  static tableColumnsByTableName = (tableName: string) => `/table-columns?table=${tableName}`;
  static defaultTableColumnsByTableName = (tableName: string) =>
    `/table-columns/default?table=${tableName}`;
  static tableViewsByTableName = (tableName: string) => `/table-views?table=${tableName}`;
  static phoneContactById = (phoneContact: number) => `/phone-contacts/${phoneContact}`;
  static convertToCandidateById = (candidateId: number) =>
    `/users/user-contact/${candidateId}/add-candidate-role`;

  static excelImport = '/excel/import';
  static excelImportValidate = '/excel/import/validate';
  static excelImportStatus = '/excel/import/status';
  static excelImportCancel = (importStatusId: number) => `/excel/import/${importStatusId}`;
  static excelTemplate = '/excel/template';
}
